var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { hidden: !_vm.isVisible } }, [
    _c("div", { staticClass: "lableFormContainer" }, [
      _c("h2", { attrs: { id: _vm.question.id + "Frage" } }, [
        _vm._v(_vm._s(_vm.question.questionText))
      ])
    ]),
    _vm._v(" "),
    _vm.question.description
      ? _c("div", { domProps: { innerHTML: _vm._s(_vm.question.description) } })
      : _vm._e(),
    _vm._v(" "),
    _vm.hasError
      ? _c("div", { staticClass: "errorBox error" }, [
          _c("strong", [_vm._v(_vm._s(_vm.errorText))])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.question.propertyInfo.type == "EMAIL"
      ? _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.valueInt,
                expression: "valueInt"
              }
            ],
            attrs: { type: "text", id: _vm.question.id },
            domProps: { value: _vm.valueInt },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.valueInt = $event.target.value
              }
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.question.propertyInfo.type == "STRING"
      ? _c("div", [
          _vm.showSocialMediaUrlHint
            ? _c("div", [_vm._v(_vm._s(_vm.getSocialMediaHintText()))])
            : _vm._e(),
          _vm._v(" "),
          _vm.readOnly
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.valueInt,
                    expression: "valueInt"
                  }
                ],
                attrs: { type: "text", id: _vm.question.id, readonly: "" },
                domProps: { value: _vm.valueInt },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.valueInt = $event.target.value
                  }
                }
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.valueInt,
                    expression: "valueInt"
                  }
                ],
                attrs: {
                  type: "text",
                  id: _vm.question.id,
                  autocomplete: "new-password"
                },
                domProps: { value: _vm.valueInt },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.valueInt = $event.target.value
                  }
                }
              })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.question.propertyInfo.type.kind == "NUMBER"
      ? _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.valueInt,
                expression: "valueInt"
              }
            ],
            attrs: { type: "text", id: _vm.question.id },
            domProps: { value: _vm.valueInt },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.valueInt = $event.target.value
              }
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.question.propertyInfo.type.kind == "CHOICE"
      ? _c(
          "div",
          _vm._l(_vm.question.propertyInfo.type.allowedValues, function(
            value,
            index
          ) {
            return _c("div", { staticClass: "radioCheckContainer" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.valueInt,
                    expression: "valueInt"
                  }
                ],
                attrs: {
                  id: _vm.question.id + "_" + index,
                  type: "radio",
                  name: _vm.question.id
                },
                domProps: {
                  value: value,
                  checked: _vm._q(_vm.valueInt, value)
                },
                on: {
                  __c: function($event) {
                    _vm.valueInt = value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: _vm.question.id + "_" + index } }, [
                _vm._v(_vm._s(value))
              ])
            ])
          })
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.question.propertyInfo.type.kind == "MULTICHOICE"
      ? _c(
          "div",
          _vm._l(_vm.question.propertyInfo.type.allowedValues, function(
            value,
            index
          ) {
            return _c("div", { staticClass: "radioCheckContainer" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.valueInt,
                    expression: "valueInt"
                  }
                ],
                attrs: {
                  id: _vm.question.id + "_" + index,
                  type: "checkbox",
                  name: _vm.question.id
                },
                domProps: {
                  value: value,
                  checked: Array.isArray(_vm.valueInt)
                    ? _vm._i(_vm.valueInt, value) > -1
                    : _vm.valueInt
                },
                on: {
                  __c: function($event) {
                    var $$a = _vm.valueInt,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = value,
                        $$i = _vm._i($$a, $$v)
                      if ($$c) {
                        $$i < 0 && (_vm.valueInt = $$a.concat($$v))
                      } else {
                        $$i > -1 &&
                          (_vm.valueInt = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.valueInt = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: _vm.question.id + "_" + index } }, [
                _vm._v(_vm._s(value))
              ])
            ])
          })
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.question.propertyInfo.type.kind == "SCALE"
      ? _c(
          "div",
          [
            _vm._l(_vm.question.propertyInfo.type.allowedValues, function(
              value,
              index
            ) {
              return _c(
                "div",
                {
                  staticClass: "radioCheckContainer",
                  staticStyle: { float: "left" }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.valueInt,
                        expression: "valueInt"
                      }
                    ],
                    attrs: {
                      id: _vm.question.id + "_" + index,
                      type: "radio",
                      name: _vm.question.id
                    },
                    domProps: {
                      value: value,
                      checked: _vm._q(_vm.valueInt, value)
                    },
                    on: {
                      __c: function($event) {
                        _vm.valueInt = value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { attrs: { for: _vm.question.id + "_" + index } },
                    [_vm._v(_vm._s(value))]
                  )
                ]
              )
            }),
            _vm._v(" "),
            _c("div", { staticStyle: { clear: "both" } })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.question.propertyInfo.type.kind == "DATETIME"
      ? _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.valueInt,
                expression: "valueInt"
              }
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.valueInt },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.valueInt = $event.target.value
              }
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.question.propertyInfo.type == "BOOLEAN"
      ? _c("div", [
          _c("div", { staticClass: "radioCheckContainer" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.valueInt,
                  expression: "valueInt"
                }
              ],
              attrs: { type: "checkbox", id: _vm.question.id },
              domProps: {
                checked: Array.isArray(_vm.valueInt)
                  ? _vm._i(_vm.valueInt, null) > -1
                  : _vm.valueInt
              },
              on: {
                __c: function($event) {
                  var $$a = _vm.valueInt,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$c) {
                      $$i < 0 && (_vm.valueInt = $$a.concat($$v))
                    } else {
                      $$i > -1 &&
                        (_vm.valueInt = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.valueInt = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: _vm.question.id } }, [_vm._v(" ")])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.question.propertyInfo.type.kind == "DOUBLE_OPTIN"
      ? _c("div", [
          _c("div", { staticClass: "radioCheckContainer" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.valueInt,
                  expression: "valueInt"
                }
              ],
              attrs: { type: "checkbox", id: _vm.question.id },
              domProps: {
                checked: Array.isArray(_vm.valueInt)
                  ? _vm._i(_vm.valueInt, null) > -1
                  : _vm.valueInt
              },
              on: {
                __c: function($event) {
                  var $$a = _vm.valueInt,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$c) {
                      $$i < 0 && (_vm.valueInt = $$a.concat($$v))
                    } else {
                      $$i > -1 &&
                        (_vm.valueInt = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.valueInt = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: _vm.question.id } }, [_vm._v(" ")])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.question.propertyInfo.type.kind == "ADDRESS"
      ? _c(
          "div",
          [
            _c("address-question", {
              ref: "addressQuestion",
              attrs: { question: _vm.question }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.question.propertyInfo.type == "COUNTRY"
      ? _c("div", [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.valueInt,
                  expression: "valueInt"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.valueInt = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.countries, function(country) {
              return _c("option", [_vm._v(_vm._s(country))])
            })
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.question.propertyInfo.type.kind == "MATRIX"
      ? _c(
          "div",
          { staticClass: "oldGridSurvey" },
          [
            _c(
              "div",
              { staticClass: "clearfix hidden-md-down" },
              [
                _c(
                  "div",
                  { staticClass: "gridTitle", staticStyle: { width: "40%" } },
                  [_vm._v(" ")]
                ),
                _vm._v(" "),
                _vm._l(_vm.question.propertyInfo.type.columns, function(
                  column
                ) {
                  return _c(
                    "div",
                    {
                      staticClass: "gridValue",
                      style:
                        "width:calc(60% / " +
                        _vm.question.propertyInfo.type.columns.length +
                        ")"
                    },
                    [_vm._v(_vm._s(column))]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(_vm.question.propertyInfo.type.rows, function(
              row,
              rowIndex
            ) {
              return _c(
                "div",
                { staticClass: "clearfix" },
                [
                  _c(
                    "div",
                    { staticClass: "gridTitle", staticStyle: { width: "40%" } },
                    [_vm._v(_vm._s(row))]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.question.propertyInfo.type.columns, function(
                    column,
                    columnIndex
                  ) {
                    return _c(
                      "div",
                      {
                        staticClass: "gridValue",
                        style:
                          "width:calc(60% / " +
                          _vm.question.propertyInfo.type.columns.length +
                          ")"
                      },
                      [
                        _c("div", { staticClass: "radioCheckContainer" }, [
                          _vm.question.propertyInfo.type.type ==
                          "SINGLE_VALUE_ROW"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.valueInt[row],
                                    expression: "valueInt[row]"
                                  }
                                ],
                                attrs: {
                                  type: "radio",
                                  id:
                                    _vm.question.id +
                                    "_" +
                                    rowIndex +
                                    "_" +
                                    columnIndex,
                                  name: _vm.question.id + "_" + rowIndex
                                },
                                domProps: {
                                  value: { left: row, right: column },
                                  checked: _vm._q(_vm.valueInt[row], {
                                    left: row,
                                    right: column
                                  })
                                },
                                on: {
                                  __c: function($event) {
                                    var $$exp = _vm.valueInt,
                                      $$idx = row
                                    if (!Array.isArray($$exp)) {
                                      _vm.valueInt[row] = {
                                        left: row,
                                        right: column
                                      }
                                    } else {
                                      $$exp.splice($$idx, 1, {
                                        left: row,
                                        right: column
                                      })
                                    }
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.question.propertyInfo.type.type ==
                          "MULTI_VALUE_ROW"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.valueInt[row],
                                    expression: "valueInt[row]"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id:
                                    _vm.question.id +
                                    "_" +
                                    rowIndex +
                                    "_" +
                                    columnIndex,
                                  name: _vm.question.id + "_" + rowIndex
                                },
                                domProps: {
                                  value: { left: row, right: column },
                                  checked: Array.isArray(_vm.valueInt[row])
                                    ? _vm._i(_vm.valueInt[row], {
                                        left: row,
                                        right: column
                                      }) > -1
                                    : _vm.valueInt[row]
                                },
                                on: {
                                  __c: function($event) {
                                    var $$a = _vm.valueInt[row],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = { left: row, right: column },
                                        $$i = _vm._i($$a, $$v)
                                      if ($$c) {
                                        $$i < 0 &&
                                          (_vm.valueInt[row] = $$a.concat($$v))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.valueInt[row] = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      var $$exp = _vm.valueInt,
                                        $$idx = row
                                      if (!Array.isArray($$exp)) {
                                        _vm.valueInt[row] = $$c
                                      } else {
                                        $$exp.splice($$idx, 1, $$c)
                                      }
                                    }
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "clearfix",
                              attrs: {
                                for:
                                  _vm.question.id +
                                  "_" +
                                  rowIndex +
                                  "_" +
                                  columnIndex
                              }
                            },
                            [_c("span", [_vm._v(_vm._s(column))])]
                          )
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.question.confirm
      ? _c("div", { staticClass: "radioCheckContainer" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.confirmed,
                expression: "confirmed"
              }
            ],
            attrs: { type: "checkbox", id: _vm.question.id + "confirm" },
            domProps: {
              checked: Array.isArray(_vm.confirmed)
                ? _vm._i(_vm.confirmed, null) > -1
                : _vm.confirmed
            },
            on: {
              __c: function($event) {
                var $$a = _vm.confirmed,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$c) {
                    $$i < 0 && (_vm.confirmed = $$a.concat($$v))
                  } else {
                    $$i > -1 &&
                      (_vm.confirmed = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.confirmed = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _vm.question.propertyInfo.type.kind == "ADDRESS"
            ? _c("label", { attrs: { for: _vm.question.id + "confirm" } }, [
                _vm._v("Ja, meine Adresse ist korrekt")
              ])
            : _c("label", { attrs: { for: _vm.question.id + "confirm" } }, [
                _vm._v(" ")
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.question.afterQuestionContent
      ? _c("div", {
          domProps: { innerHTML: _vm._s(_vm.question.afterQuestionContent) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4bf4ad09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bf4ad09","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionListEntry.vue
// module id = 243
// module chunks = 2